import { ProtectedRoute } from "@/components/ProtectedRoute";
import { createFileRoute } from "@tanstack/react-router";
import { LessonDraftsPage } from "../../../../pages/lesson/LessonDraftsPage";

export const Route = createFileRoute("/admin/lesson/$lessonId/drafts")({
  component: ProtectedLessonDraftsPage,
});

function ProtectedLessonDraftsPage() {
  return (
    <ProtectedRoute>
      <LessonDraftsPage />
    </ProtectedRoute>
  );
}
